import { Center, Divider } from "@chakra-ui/react"
import { FeaturesComponent } from "../../components/features"
import { HeroComponent } from "../../components/hero"
import { DefaultTemplate } from "../../components/templates"
import { TestimoniesComponent } from "../../components/testimonies"

export const App = () => {
  return (
    <DefaultTemplate>
      <HeroComponent />

      <Center>
        <Divider bg={"grey.200"} border={2} maxW={"98vw"} />
      </Center>

      <FeaturesComponent />

      <Center>
        <Divider bg={"grey.200"} border={2} maxW={"98vw"} />
      </Center>

      <TestimoniesComponent />
    </DefaultTemplate>
  )
}
